import { USER_TYPE } from "shared";

export function buildPriceRequestKey({
  products,
  dossier,
  selectedCustomerCustomerId,
  companyIds,
}) {
  const productIds = [...products]
    .map((product) => `${product.Dossier}:${product.Nummer}`)
    .sort()
    .join(",");
  const companyIdStr = [...(companyIds ?? [])].map(String).sort().join(",");
  return `${dossier}|${selectedCustomerCustomerId}|${companyIdStr}|${productIds}`;
}

let inFlightPriceRequestKey = null;

export function claimPriceRequest(requestKey) {
  if (inFlightPriceRequestKey === requestKey) {
    return false;
  }
  inFlightPriceRequestKey = requestKey;
  return true;
}

export function releasePriceRequest() {
  inFlightPriceRequestKey = null;
}

export function getCompanyIdsForDossier(user, dossier) {
  if (!user || user.userType !== USER_TYPE.EMPLOYEE) {
    return [];
  }

  const dossierNr = Number(dossier);

  // Send IDs of all sister companies (other dossiers) so the backend can
  // fetch their intercompany prices for the current dossier's articles.
  const otherCompanies = (user.companies ?? []).filter(
    (company) => Number(company.dossier) !== dossierNr
  );

  if (otherCompanies.length > 0) {
    return otherCompanies.map((company) => company._id);
  }

  return (user.companyIDs ?? []).filter(Boolean);
}
